<script setup>
import { watch } from 'vue'
import { useRouter } from 'vue-router'
import ActionModal from '@/components/modals/ActionModal.vue'
import { SITES_UPGRADE_PATH } from '@/Utils/sitesPlanLimits'
import { trackSites, SITES_EVENTS } from '@/lib/tracking/sites'

// Shown when a Sites plan limit (sites / maxSites / sites:custom-domain) blocks
// an action: the control stays visible and clickable, this explains why.
const props = defineProps({
	title: {
		type: String,
		default: 'Upgrade your plan',
	},
	body: {
		type: String,
		default: '',
	},
	/** SITES_UPGRADE_REASONS value sent with `sites_upgrade_prompt_shown`; nothing is sent without one. */
	reason: {
		type: String,
		default: '',
	},
	site: {
		type: [Object, String],
		default: null,
	},
	/** Plan counts for the event (`sites_used`, `max_sites`, `custom_domains_used`, `max_custom_domains`). */
	counts: {
		type: Object,
		default: () => ({}),
	},
})

const isVisible = defineModel('isVisible', { type: Boolean, default: false })
const router = useRouter()

watch(isVisible, (open) => {
	if (!open || !props.reason) return
	trackSites(SITES_EVENTS.UPGRADE_PROMPT_SHOWN, props.site, { reason: props.reason, surface: 'modal', ...props.counts })
}, { flush: 'post' })

const upgrade = () => router.push(SITES_UPGRADE_PATH)
</script>

<template>
	<ActionModal v-model:is-visible="isVisible" :title="title" confirm-text="Upgrade plan" cancel-text="Later"
		:on-submit="upgrade">
		<p class="mb-0" data-testid="sites-upgrade-body">
			{{ body }}
			See the <a target="_blank" rel="noopener" class="underline" href="https://castr.com/pricing">pricing page</a>
			for the plans that include it.
		</p>
	</ActionModal>
</template>
